import { FC } from 'react'
import { BleConnectionLogsSection, HasSidebarLayout, ListHeader, TabGroupFilter, WagnerDeviceFirmwareSettings } from 'src/components'
import { SearchParamsKeys } from 'src/enums'

const WagnerDeviceFirmware: FC = () => {
  document.title = 'CLīMIT Admin Panel - RapidRH devices'

  return (
    <HasSidebarLayout>
      <ListHeader title="RapidRH devices" />
      <TabGroupFilter
        statusList={[
          {
            status: 'Settings',
            content: <WagnerDeviceFirmwareSettings />
          },
          {
            status: 'BLE connection logs',
            content: <BleConnectionLogsSection />
          }
        ]}
        name={SearchParamsKeys.WagnerDeviceFirmwareTab}
        paramsToRemove={[
          SearchParamsKeys.Page,
          SearchParamsKeys.RowsPerPage,
          SearchParamsKeys.Contractor,
          SearchParamsKeys.ProjectId,
          SearchParamsKeys.EventType,
          SearchParamsKeys.ProbeRawId,
          SearchParamsKeys.AppVersion,
          SearchParamsKeys.DeviceOS,
          SearchParamsKeys.Search
        ]}
      />
    </HasSidebarLayout>
  )
}

export default WagnerDeviceFirmware
